export default "__VITE_ASSET__BRQTWse1__"